<template>
  <v-main>
    <navigation v-if="!liffUser" extension>
      <template v-slot:extension>
        <v-tabs :value="$route.path" grow>
          <v-tab to="/analytics/patient-recommend">{{ $t('Analytics.patientRecommend') }}</v-tab>
          <v-tab to="/analytics/online-reserve">{{ $t('Analytics.onlineReserveResult') }}</v-tab>
          <v-tab to="/analytics/patient-analysis">病患分析</v-tab>
        </v-tabs>
      </template>
    </navigation>
    <v-tabs v-else :value="$route.path" grow>
      <v-tab to="/analytics/patient-recommend">{{ $t('Analytics.patientRecommend') }}</v-tab>
      <v-tab to="/analytics/online-reserve">{{ $t('Analytics.onlineReserveResult') }}</v-tab>
      <v-tab to="/analytics/patient-analysis">病患分析</v-tab>
    </v-tabs>

    <router-view></router-view>

  </v-main>
</template>

<script>
import Navigation from "@/components/Navigation";
import { mapGetters } from "vuex";

export default {
  name: "AnalyticsIndex",
  components: { Navigation },
  computed: {
    ...mapGetters([
      'liffUser'
    ]),
  },
}
</script>

<style scoped>

</style>
